import React__default from "react";
const RouterContext = React__default.createContext({
  navigate: () => null
});
export {
  RouterContext
};
